import React from 'react';
import { Table, Badge, Alert, Card } from 'react-bootstrap';

/**
 * Helper to create a Bootstrap Badge for the mock exam state
 */
const getStateBadge = (state) => {
  const stateLower = state?.toLowerCase();
  if (stateLower === 'approved') {
    return <Badge bg="success">Approved</Badge>;
  }
  if (stateLower === 'pending') {
    return (
      <Badge bg="warning" text="dark">
        Pending
      </Badge>
    );
  }
  if (stateLower === 'rejected') {
    return <Badge bg="danger">Rejected</Badge>;
  }
  return <Badge bg="secondary">{state || 'N/A'}</Badge>;
};

/**
 * Renders the specific report for a single Mock Exam (REPORT_KINDS.MOCK)
 */
function MockReportView({ reportData, selectedUsers }) {
  // Get all student IDs that have results in the report
  const allResultIds = Object.keys(reportData.report);

  // Filter this list based on the user's selection
  const studentIdsToDisplay =
    selectedUsers && selectedUsers.length > 0
      ? allResultIds.filter((id) => selectedUsers.includes(id))
      : allResultIds;

  if (studentIdsToDisplay.length === 0) {
    return (
      <Alert variant="info">
        No mock exam results found for the selected students.
      </Alert>
    );
  }

  // Get mock name from the first result (assuming all are the same mock)
  let mockName = 'Mock Report';
  try {
    mockName = reportData.report[studentIdsToDisplay[0]][0].mockName;
  } catch (e) {
    /* ignore, default title is fine */
  }

  return (
    <>
      <Card.Title as="h6">{mockName} Results</Card.Title>
      <Table striped bordered hover responsive size="sm">
        <thead>
          <tr>
            <th>Student Name</th>
            <th>Marks</th>
            <th>State</th>
          </tr>
        </thead>
        <tbody>
          {studentIdsToDisplay.map((studentId) => {
            const results = reportData.report[studentId];

            // Should not happen based on logic, but a good safeguard
            if (!results || results.length === 0) return null;

            // A student might have multiple attempts, so map over them
            return results.map((result, index) => (
              <tr key={studentId + '-' + index}>
                <td>{result.userName}</td>
                <td>{result.marks}</td>
                <td>{getStateBadge(result.state)}</td>
              </tr>
            ));
          })}
        </tbody>
      </Table>
    </>
  );
}

export default MockReportView;